module.exports = __webpack_public_path__ + "images/gather-header__EU_jZ.png";